import { CartAddEvent } from '@theme/events';

class NightPreviewReader extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    this.sticky = this.querySelector('.night-reader__sticky') || this.sticky;
    if (!this.sticky) return;
    // Escape section transforms so the purchase bar stays attached to the viewport.
    document.body.append(this.sticky);
    this.sticky.querySelector('form').addEventListener('submit', (event) => this.add(event), { signal: this.abort.signal });
  }

  disconnectedCallback() {
    this.abort?.abort();
    this.sticky?.remove();
  }

  async add(event) {
    event.preventDefault();
    if (this.pending) return;
    const form = event.currentTarget;
    const button = form.querySelector('button');
    const status = form.querySelector('[role="status"]');
    const label = button.textContent;
    this.pending = true;
    button.disabled = true;
    button.textContent = 'Wird hinzugefügt…';
    status.textContent = '';
    let added = false;
    try {
      const body = new FormData(form);
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((node) => node.dataset.sectionId))].slice(0, 5);
      body.set('sections', sections.join(','));
      body.set('sections_url', location.pathname);
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', body, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'Das Buch konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
      added = true;
      let cart;
      try {
        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) cart = await cartResponse.json();
      } catch { /* The add succeeded; do not prompt a duplicate purchase attempt. */ }
      this.dispatchEvent(new CartAddEvent(cart, String(body.get('id')), {
        source: 'night-preview-reader-de', itemCount: 1, productId: this.dataset.productId, sections: result.sections,
      }));
      status.textContent = 'Zum Warenkorb hinzugefügt.';
    } catch (error) {
      status.textContent = added ? 'Zum Warenkorb hinzugefügt. Öffne den Warenkorb, um fortzufahren.' : error.message;
    } finally {
      this.pending = false;
      button.disabled = false;
      button.textContent = label;
    }
  }
}

if (!customElements.get('night-preview-reader-de')) customElements.define('night-preview-reader-de', NightPreviewReader);
